
export enum AuctionStatus {
    "draft" = "draft",
    "planned" = "planned",
    "active" = "active",
    "closed" = "closed",
    "deleted" = "deleted",
    "winners_selection" = "winners_selection",
    "winners_selection_completed" = "winners_selection_completed",
    "canceled" = "canceled",
    "expired" = "expired"
}
